import React, {useEffect, useState} from 'react';

import ArrowDown from '../../../../assets/icons/arrow-down.svg';

type CountryDropdownProps = {
  value: string;
  onChange: (country: string) => void;
  error?: string;
  className?: string;
};

const CountryDropdown: React.FC<CountryDropdownProps> = ({
  value,
  onChange,
  error,
  className = '',
}) => {
  const [countries, setCountries] = useState<string[]>([]);

  type RestCountry = {
    name?: {
      common?: string;
    };
  };

  useEffect(() => {
    fetch('https://restcountries.com/v3.1/all?fields=name')
      .then((res) => res.json())
      .then((data: unknown) => {
        const countriesData = Array.isArray(data)
          ? (data as RestCountry[])
          : [];
        const countryNames = countriesData
          .map((c) => c.name?.common)
          .filter((name): name is string => Boolean(name))
          .sort((a, b) => a.localeCompare(b));
        setCountries(countryNames);
      })
      .catch(() => {
        setCountries([]); // Optional fallback or error state
      });
  }, []);

  return (
    <div className={`relative ${className}`}>
      {error && (
        <p className="text-smoothRed text-sm font-medium mt-1">{error}</p>
      )}
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={`
            w-full 
            appearance-none 
            bg-white 
            border 
            border-subtleGrey
            rounded-t-md 
            px-4 
            py-4 
            text-headlineGrayscale 
            focus:outline-none 
            focus:ring-none 
            ${error ? 'border-red-500' : ''}
          `}>
          <option value="" disabled>
            Select a country
          </option>
          {countries.map((country) => (
            <option key={country} value={country}>
              {country}
            </option>
          ))}
        </select>
        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
          <img src={ArrowDown} alt="Dropdown" className="h-4 w-4" />
        </div>
      </div>
    </div>
  );
};

export default CountryDropdown;
